// Dependencies
import React from 'react'
import _ from 'lodash'
import { AppContext } from '../contexts/AppContext'
import styled, {css} from 'styled-components'

// Types
import { Types, Containers } from '../types'
 
// Hooks
import { useDebug } from '../hooks'

import SimpleProductProvider, { SimpleProductContext } from '../contexts/SimpleProduct';
import VariableProductProvider, { VariableProductContext } from '../contexts/VariableProduct';
import BundleProductProvider, { BundleProductContext } from '../contexts/BundleProduct';

import SimpleProduct from './SimpleProduct'
import VariableProduct from './VariableProduct'
import BundleProduct from './BundleProduct'
 
const productContextsMap: any = {
  simple: {
    View: SimpleProduct, 
    Context: SimpleProductContext,
    Provider: SimpleProductProvider
  },
  variable: {
    View: VariableProduct,
    Context: VariableProductContext,
    Provider: VariableProductProvider
  },
  bundle: {
    View: BundleProduct,
    Context: BundleProductContext,
    Provider: BundleProductProvider
  } 
}

const ProductView = ({product, ...props}: any) => {
  useDebug(`Product [${product.name}]`)

  const Product = React.useMemo(() => {

    if ( !(product?.type in productContextsMap) ) {
      throw Error(`Product type "${product.type}" is not supported.`);
    }
 
    return productContextsMap[product.type];

  }, [product.type]);
 

  return (
    <Product.Provider {...{product, ...props}}>
      <Product.View context={Product.Context} />
    </Product.Provider>
  )

}

export default ProductView;